import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export default function NotFound() {
  const { settings } = useApp();
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="text-center">
        <img
          src={settings?.logo_url || "/brand/lepo-gete.png"}
          alt={settings?.org_name || "Lepo Gete"}
          className="mx-auto h-16 md:h-20 w-auto object-contain mb-8"
          onError={(e)=>{e.target.style.display='none';}}
        />
        <div className="font-display text-6xl md:text-7xl mb-4 tracking-tight">404</div>
        <p className="text-sm md:text-base text-[#141414]/70 max-w-sm mx-auto">
          Halaman yang Anda cari tidak ditemukan.<br/>The page you are looking for was not found.
        </p>
        <Link to="/" data-testid="nf-home" className="inline-block mt-8 flat-btn-primary rounded-full px-5 py-2.5 text-sm font-semibold">
          ← Beranda
        </Link>
      </div>
    </div>
  );
}
